import getLocalString from "constants/Localization";
import { useUpdateProposalInfoMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import React from "react";

export default function useUpdateProposalInfo() {
  const [mutation, { loading, data, error }] = useUpdateProposalInfoMutation();

  const [updateProposalInfo, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateProposalInfo",
    },
    {
      successMessage: getLocalString("proposals.update-proposal-info-success"),
      failureMessage: getLocalString("proposals.update-proposal-info-failure"),
    }
  );

  return [updateProposalInfo, context] as const;
}
